// Relative import: this module is also compiled by the server tsconfig, which has no `~` alias.
import type {ListVariation} from '../types'

/**
 * LEVANTA, its LEVANTA_V2 sandbox, the CC (Creator Connections) lists and the VERDICT page share every
 * Levanta page rule (no sponsored, no related lists, no DWS dictionary, no brand cap, hard 404 without a
 * ranking, noindex). CC products carry no levantaLink, so their buttons stay plain Amazon links; a VERDICT
 * page decides the link per product (see verdict-link.ts).
 */
export function isLevantaVariation(variation: ListVariation | undefined): boolean {
  return variation === 'LEVANTA' || variation === 'LEVANTA_V2' || variation === 'CC' || variation === 'VERDICT'
}

/** The one-hero VERDICT page under /pick/. Only this variation renders the verdict layout and the per-product link rule. */
export function isVerdictVariation(variation: ListVariation | undefined): boolean {
  return variation === 'VERDICT'
}

/**
 * Route names of the list pages served under a path prefix (/lv/, /lv2/, /cc/ → levanta_slug_page;
 * /pick/ → pick_slug_page). They are list pages whose slug is the path minus the prefix, and they are never indexed.
 */
export const PREFIXED_LIST_ROUTE_NAMES = ['levanta_slug_page', 'pick_slug_page'] as const

export function isPrefixedListRoute(routeName: string | undefined): boolean {
  return (PREFIXED_LIST_ROUTE_NAMES as readonly string[]).includes(routeName ?? '')
}

/** The path prefix of every prefixed list route; stripping it yields the catalog slug path. */
export const LIST_PATH_PREFIX = /^\/(lv2?|cc|pick)\//
